<template>
    <div class="login"
        v-loading.lock="fullscreenLoading"
        element-loading-text="登录中..."
        element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <div class="log-wrap">
            <div class="left">
                <img src="../../imgs/logo.png" alt="">
            </div>
            <div class="right">
                <h1>欢迎登录</h1>
                <el-form :model="loginForm" :rules="rules" ref="loginForm">
                    <el-form-item prop="username">
                        <el-input style="width: 100%;border: none;" v-model="loginForm.username" placeholder="用户名"><i slot="prefix" class="el-input__icon el-icon-user-solid"></i></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input style="width: 100%;" :type="type" placeholder="密码" v-model="loginForm.password" @keyup.native.enter="showCaptcha">
                            <i v-show="showPwd" style="color: blue" slot="suffix" class="el-input__icon el-icon-view" @click="handleShowPwd"></i>
                            <i v-show="!showPwd" slot="suffix" class="iconfont icon-yincang" @click="handleShowPwd"></i>
                            <i slot="prefix" class="el-input__icon el-icon-s-claim"></i>
                        </el-input>
                    </el-form-item>
<!--                    <el-form-item prop="sign">
                        <el-input style="width: 50%;border: none;float: left;margin-right:20px" v-model="loginForm.sign" placeholder="验证码"><i slot="prefix" class="el-input__icon el-icon-circle-check"></i></el-input>
                        <a v-if="this.count == 0" style="text-decoration:none;color: #0043ff;" @click="getSign" href="javascript:;">获取验证码</a>
                        <span v-else style="color:#0043ff">{{count}}秒</span>
                    </el-form-item>-->
                    <el-form-item>
                        <el-button
                                type="primary"
                                @click="showCaptcha"
                                :loading="loading"
                                class="submit_btn"
                                :round="true"
                        >
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
      <Verify ref="captcha" mode="pop" :captchaType="captchaType" :imgSize="{ width: '330px', height: '155px' }" @success="captchaSuccess"/>
    </div>
</template>

<script>
    import { login,getSign } from "../../api/api";
    import { sha256 } from "@/utilities";
    import Verify from '../../components/verifition/Verify'


    const validatePass = (rule, value, callback) => {
      var reg = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[\W_]).{8,32}$/;
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if(!reg.test(value)){
        callback(new Error('密码必须是8-32位字符，且包含字母、数字、特殊符号'));
      }else {
        callback();
      }
    };

    export default {
        name: 'login',
        components: {
          Verify
        },
        data(){
            return {
                type: 'password',
                showPwd: false,
                centerDialogVisible_pwd: false,
                fullscreenLoading: false,
                loading: false,
                captchaType: 'blockPuzzle',
                ruleForm: {
                    pass: '',
                    checkPass: '',
                    age: ''
                },
                loginForm: {
                    username: '',
                    password: '',
                    captcha: '',
                    sign:''//验证码
                },
                rules: {
                    username: [
                        { required: true, message: '请输入用户名', trigger: 'blur' },
                    ],
                    password: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    /*sign: [
                        { required: true, message: '请输入验证码', trigger: 'blur' },
                        { min: 4, max: 6, message: '长度在4-6个数字', trigger: 'blur' }
                    ],*/
                },
                show: true,
                count: 0,//倒计时
                timer: null,
            }
        },
        methods:{
            getCaptchaType() {
              /*let types=['blockPuzzle','clickWord'];
              return types[Math.floor(Math.random() * 2)];*/
              return 'blockPuzzle';
            },
            showCaptcha() {
              this.$refs.loginForm.validate(async (valid) => {
                console.log('loginForm.validate',valid)
                if (valid) {
                  this.captchaType=this.getCaptchaType();
                  this.$refs.captcha.show();
                }
              });
            },
            captchaSuccess(params) {
              this.loginForm.captcha=params.captchaVerification;
              this.submitForm('loginForm')
            },
            getCode(){
                const TIME_COUNT = 60;
                if (!this.timer) {
                    this.count = TIME_COUNT;
                    this.show = false;
                    this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                        } else {
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000)
                }
            },
            async ajaxGetSign(){
                try {
                    const res = await getSign(Number(this.loginForm.username));
                    if(res.code == 0){
                        this.getCode();
                    }else{

                    }
                } catch (error) {
                    console.log(error);
                }
            },
            getSign(){
                if(this.loginForm.username == "" || this.loginForm.username.length < 11){
                    this.$message({
                        message: '请填写手机号码',
                        type: 'warning'
                    });
                    return;
                }
                if(this.count == 0 || this.count == ""){
                    this.ajaxGetSign();
                }
            },
            handleKeyDown(){
                //回车登录
                this.submitForm('loginForm');
            },
            handleShowPwd(){
                this.showPwd = !this.showPwd;
                if(this.showPwd){
                    this.type = "text";
                }else{
                    this.type = "password";
                }
            },
            async submitForm(formName) {
                this.fullscreenLoading = true;
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        try {

                            let loginPwd=await sha256(this.loginForm.username+"||"+this.loginForm.password);
                            const res = await login({
                                userNo: this.loginForm.username,
                                userPwd: loginPwd,
                                captcha: this.loginForm.captcha,
                                //sign:this.loginForm.sign
                            });
                            if(res.code == 0){
                                //存放token
                                // Cookies.set('token',res.data.token);
                                sessionStorage.setItem('token',res.data.token);
                                sessionStorage.setItem('userName',res.data.userName)
                                sessionStorage.setItem('userId',res.data.userId)
                                sessionStorage.setItem("userNo", res.data.userNo);

                                setTimeout( () => {
                                    this.fullscreenLoading = false;
                                    this.$router.push('/dashed')
                                    this.$message({
                                        type: 'success',
                                        message: '登录成功'
                                    });
                                },500 )
                            }else{
                                this.fullscreenLoading = false;
                                // this.$message.warning(res.message)
                            }
                        } catch (error) {
                            console.log( error );
                        }
                    } else {
                        this.fullscreenLoading = false;
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .login{
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: url("../../imgs/login_.png");
        background-size: cover;
    }
    .log-wrap{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        width: 800px;
        height: 480px;
        margin:auto;

        .left{
            width: 380px;
            height: 480px;
            background-image: url("../../imgs/bg.png");
            background-size: cover;

            img{
                // width: 277px;
                // height: 143px;
                display: block;
                margin: 49px auto;
            }
        }

        .right{
            width: 422px;
            height: 480px;
            background-color: #fff;
            box-sizing: border-box;
            padding: 0 20px;

            h1{
                margin-top: 106px;
                color: #333;
                font-size: 26px;
                text-align: center;
            }


        }
    }


    .el-input{
        display: block;
        width: 100%;
        border: none;
        // margin: auto;
    }

    .btn{
        display: block;
        width: 374px;
        height: 115px;
        margin: auto;
        background-image: url('../../imgs/btn.png');
        background-size: cover;
        border: none;
        outline:none;
    }

    input{
        display: block;
        // width: 332px;
        height: 30px;
        border: none;
        margin: auto;
        // padding-left: 25px;
        webkit-box-shadow: 0 0 0 1000px white inset;
        /*background: none;*/
        outline: none;

        &.input_username{
            background-image: url('../../imgs/username.png');
            background-position: 0 center;
            background-repeat: no-repeat;
            background-size: 17px 20px;
            border-bottom: 1px solid #5B8FEF;

        }
        &.input_password{
            background-image: url('../../imgs/password.png');
            background-position: 0 center;
            background-repeat: no-repeat;
            background-size: 17px 20px;
            border-bottom: 1px solid #5B8FEF;
        }
    }

    .submit_btn{
        display: block;
        width: 100%;
        height: 100px;
        margin: auto;
        background-image: url('../../imgs/btn.png');
        background-size: cover;
        /*background-image: url('../../imgs/btn.png');*/
        background-color: transparent;
        border: none;
    }
    .el-form-item__error{
        left: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue